module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [(!_vm.formSubmitted) ? _c('form', {
    staticClass: "form-refer__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-refer__label",
    class: {
      'form-refer__label--active': _vm.date
    }
  }, [_c('b', [_vm._v("Date:")])]), _c('div', {
    staticClass: "form-inputwrap datefield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date),
      expression: "date"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('date')
    },
    attrs: {
      "name": "date",
      "type": "date"
    },
    domProps: {
      "value": (_vm.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date = $event.target.value
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('date')),
      expression: "errors.has('date')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Date is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientName),
      expression: "patientName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('patientName')
    },
    attrs: {
      "name": "patientName",
      "type": "text",
      "placeholder": "Patient Name:"
    },
    domProps: {
      "value": (_vm.patientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientName = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('patientName')),
      expression: "errors.has('patientName')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Patient name is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-refer__label",
    class: {
      'form-refer__label--active': _vm.dob
    }
  }, [_c('b', [_vm._v("D.O.B.:")])]), _c('div', {
    staticClass: "form-inputwrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dob),
      expression: "dob"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('dob')
    },
    attrs: {
      "name": "dob",
      "type": "date"
    },
    domProps: {
      "value": (_vm.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dob = $event.target.value
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dob')),
      expression: "errors.has('dob')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("D.O.B. is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientPhone),
      expression: "patientPhone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[(]?[0-9]{3}[)]?[-]?[ ]?[.]?[0-9]{3}[-]?[ ]?[.]?[0-9]{4}$'),
      expression: "'required|regex:^[(]?[0-9]{3}[)]?[-]?[ ]?[.]?[0-9]{3}[-]?[ ]?[.]?[0-9]{4}$'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-refer__input--error': _vm.errors.has('patientPhone')
    },
    attrs: {
      "name": "patientPhone",
      "placeholder": "Patient Phone#:"
    },
    domProps: {
      "value": (_vm.patientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientPhone = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('patientPhone')),
      expression: "errors.has('patientPhone')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v(" Phone number is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-refer__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Patient Email:"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v(" Please Input a Valid Email")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientAddress),
      expression: "patientAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-refer__input--error': _vm.errors.has('patientAddress')
    },
    attrs: {
      "name": "patientAddress",
      "placeholder": "Patient Address:"
    },
    domProps: {
      "value": (_vm.patientAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientAddress = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('patientAddress')),
      expression: "errors.has('patientAddress')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v(" Patient Address is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dentist),
      expression: "dentist"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('dentist')
    },
    attrs: {
      "name": "dentist",
      "type": "text",
      "placeholder": "Dentist:"
    },
    domProps: {
      "value": (_vm.dentist)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dentist = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dentist')),
      expression: "errors.has('dentist')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Dentist name is required.")])]), _c('div', {
    staticClass: "form-main__group radioo_box"
  }, [_c('label', {
    staticClass: "form-refer__label",
    class: {
      'form-contact__label--active': _vm.radiopatient
    }
  }, [_vm._v("Does the patient have dental insurance?")]), _c('span', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radiopatient),
      expression: "radiopatient"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('radiopatient')
    },
    attrs: {
      "name": "radiopatient",
      "checked": "checked",
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.radiopatient, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.radiopatient = "Yes"
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Yes")])]), _c('span', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radiopatient),
      expression: "radiopatient"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('radiopatient')
    },
    attrs: {
      "name": "radiopatient",
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.radiopatient, "No")
    },
    on: {
      "change": function($event) {
        _vm.radiopatient = "No"
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("No")])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carprovider),
      expression: "carprovider"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('carprovider')
    },
    attrs: {
      "name": "carprovider",
      "type": "text",
      "placeholder": "If yes, please provide name of carrier:"
    },
    domProps: {
      "value": (_vm.carprovider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carprovider = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('carprovider')),
      expression: "errors.has('carprovider')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Provide name of carrier is required.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-refer__label full",
    class: {
      'form-refer__label--active': _vm.evaluation
    }
  }, [_vm._v("Evaluation For:")]), _c('div', {
    staticClass: "formrefer_check"
  }, [_c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation),
      expression: "evaluation"
    }],
    staticClass: "formrefercheck_input",
    attrs: {
      "type": "checkbox",
      "value": "Early Treatment",
      "name": "early"
    },
    domProps: {
      "checked": Array.isArray(_vm.evaluation) ? _vm._i(_vm.evaluation, "Early Treatment") > -1 : (_vm.evaluation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Early Treatment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.evaluation = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Early Treatment")])]), _c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation),
      expression: "evaluation"
    }],
    staticClass: "formrefercheck_input",
    attrs: {
      "type": "checkbox",
      "value": "Adolescent Treatment",
      "name": "adolescent"
    },
    domProps: {
      "checked": Array.isArray(_vm.evaluation) ? _vm._i(_vm.evaluation, "Adolescent Treatment") > -1 : (_vm.evaluation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Adolescent Treatment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.evaluation = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Adolescent Treatment")])]), _c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluation),
      expression: "evaluation"
    }],
    staticClass: "formrefercheck_input",
    attrs: {
      "type": "checkbox",
      "value": "Adult Treatment",
      "name": "adult"
    },
    domProps: {
      "checked": Array.isArray(_vm.evaluation) ? _vm._i(_vm.evaluation, "Adult Treatment") > -1 : (_vm.evaluation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.evaluation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Adult Treatment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.evaluation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.evaluation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.evaluation = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Adult Treatment")])])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluationother),
      expression: "evaluationother"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('evaluationother')
    },
    attrs: {
      "name": "evaluationother",
      "type": "text",
      "placeholder": "Other:"
    },
    domProps: {
      "value": (_vm.evaluationother)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.evaluationother = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-refer__label full",
    class: {
      'form-contact__label--active': _vm.concern
    }
  }, [_vm._v("Main Concern:")]), _c('div', {
    staticClass: "formrefer_check"
  }, [_c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Crowding",
      "name": "crowding"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Crowding") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Crowding",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Crowding")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Anterior Crossbite",
      "name": "anterior"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Anterior Crossbite") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Anterior Crossbite",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Anterior Crossbite")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Open Bite",
      "name": "openbite"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Open Bite") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Open Bite",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Open Bite")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Missing Teeth",
      "name": "missing"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Missing Teeth") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Missing Teeth",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Missing Teeth")]), _c('br')]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Oral Habits",
      "name": "oral"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Oral Habits") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Oral Habits",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Oral Habits")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Posterior Crossbite",
      "name": "posterior"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Posterior Crossbite") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Posterior Crossbite",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Posterior Crossbite")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Deep Bite",
      "name": "deepbite"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Deep Bite") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Deep Bite",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Deep Bite")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Impacted Teeth",
      "name": "impacted"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Impacted Teeth") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Impacted Teeth",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Impacted Teeth")]), _c('br')]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Class 2",
      "name": "classtwo"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Class 2") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Class 2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Class II")])]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Class 3",
      "name": "classthree"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Class 3") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Class 3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Class III")]), _c('br')]), _c('span', {
    staticClass: "response width26"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.concern),
      expression: "concern"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('concern')
    },
    attrs: {
      "type": "checkbox",
      "value": "Other",
      "name": "concern"
    },
    domProps: {
      "checked": Array.isArray(_vm.concern) ? _vm._i(_vm.concern, "Other") > -1 : (_vm.concern)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.concern,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Other",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.concern = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.concern = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.concern = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Other")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('concern')),
      expression: "errors.has('concern')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Please select options.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patientconcerns),
      expression: "patientconcerns"
    }],
    staticClass: "form-main__input",
    class: {
      'form-refer__input--error': _vm.errors.has('patientconcerns')
    },
    attrs: {
      "name": "patientconcerns",
      "type": "text",
      "placeholder": "Patient Concerns:"
    },
    domProps: {
      "value": (_vm.patientconcerns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patientconcerns = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-main__group radioo_box"
  }, [_c('label', {
    staticClass: "form-refer__label",
    class: {
      'form-contact__label--active': _vm.radiographs
    }
  }, [_c('b', [_vm._v("Radiographs Provided?")])]), _c('span', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radiographs),
      expression: "radiographs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('radiographs')
    },
    attrs: {
      "name": "radiographs",
      "checked": "checked",
      "type": "radio",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.radiographs, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.radiographs = "Yes"
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Yes")])]), _c('span', {
    staticClass: "radioclear"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radiographs),
      expression: "radiographs"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('radiographs')
    },
    attrs: {
      "name": "radiographs",
      "type": "radio",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.radiographs, "No")
    },
    on: {
      "change": function($event) {
        _vm.radiographs = "No"
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("No")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('radiographs')),
      expression: "errors.has('radiographs')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Please select one.")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('label', {
    staticClass: "form-refer__label full",
    class: {
      'form-refer__label--active': _vm.reswork
    }
  }, [_vm._v("Restorative work is:")]), _c('div', {
    staticClass: "formrefer_check"
  }, [_c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reswork),
      expression: "reswork"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('reswork')
    },
    attrs: {
      "type": "checkbox",
      "value": "Completed",
      "name": "completed"
    },
    domProps: {
      "checked": Array.isArray(_vm.reswork) ? _vm._i(_vm.reswork, "Completed") > -1 : (_vm.reswork)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reswork,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Completed",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reswork = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reswork = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reswork = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Completed")]), _c('br')]), _c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reswork),
      expression: "reswork"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('reswork')
    },
    attrs: {
      "type": "checkbox",
      "value": "Required prior to orthodontics treatment",
      "name": "reswork"
    },
    domProps: {
      "checked": Array.isArray(_vm.reswork) ? _vm._i(_vm.reswork, "Required prior to orthodontics treatment") > -1 : (_vm.reswork)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reswork,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Required prior to orthodontics treatment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reswork = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reswork = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reswork = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Required prior to orthodontics treatment")]), _c('br')]), _c('span', {
    staticClass: "response"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reswork),
      expression: "reswork"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "formrefercheck_input",
    class: {
      'form-contact__input--error': _vm.errors.has('reswork')
    },
    attrs: {
      "type": "checkbox",
      "value": "Required following orthodontics treatment",
      "name": "resfollow"
    },
    domProps: {
      "checked": Array.isArray(_vm.reswork) ? _vm._i(_vm.reswork, "Required following orthodontics treatment") > -1 : (_vm.reswork)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reswork,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Required following orthodontics treatment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reswork = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reswork = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reswork = $$c
        }
      }
    }
  }), _c('div', {
    staticClass: "formrefercheck_label"
  }, [_vm._v("Required following orthodontics treatment")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reswork')),
      expression: "errors.has('reswork')"
    }],
    staticClass: "form-refer__error-message"
  }, [_vm._v("Please select options.")])]), _c('div', {
    staticClass: "form-refer__button-group"
  }, [_c('div', {
    staticClass: "form-refer__submit-button active",
    on: {
      "click": _vm.validate
    }
  }, [_c('span', [_vm._v("Submit")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c5c2f86","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/refer-form/refer-form.pug
// module id = 651
// module chunks = 1